<main>
    <div id="contentAll">
        <div class="innerContentWrapper">
            <div id="schoolWrapper" class="waiverCard">
                <div layout="column" class="md-inline-form inputLogin">
                    <div id="serverErrorModal" class="serverErrorModal" >
                        <div class="serverErrorMessage" >
                            <h2>Oops! There has been an error.</h2>
                            <div class="fontDiv">
                                Please <span class="underlineThis"> <a [routerLink]="targetUrl" style="color:#ffff">click here </a></span> to try again
                            </div>
                            <div class="timeStamp"><p class="fontDiv">{{timeNow}}</p></div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</main>